import type { IconData } from '@stacksjs/iconify-core'

export const watch1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5c-2.62 0-4.585.174-5.998.383c-2.09.31-3.514 1.957-4 3.915l-.604 2.433A18.9 18.9 0 0 1 24 5c3.926 0 7.573 1.19 10.601 3.23l-.603-2.432c-.486-1.958-1.91-3.605-4-3.915C28.585 1.674 26.621 1.5 24 1.5m-9.998 40.702l-.604-2.433A18.9 18.9 0 0 0 24 43c3.926 0 7.573-1.19 10.601-3.23l-.603 2.432c-.486 1.958-1.91 3.605-4 3.915c-1.413.209-3.377.383-5.998.383c-2.62 0-4.585-.174-5.998-.383c-2.09-.31-3.514-1.957-4-3.915M7.5 24c0-9.113 7.387-16.5 16.5-16.5S40.5 14.887 40.5 24S33.113 40.5 24 40.5S7.5 33.113 7.5 24\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default watch1Solid
